import { GridActionsCellItem } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import { IconButtonProps } from '@mui/material';
import { JSX } from 'react';

/**
 * Delete button for DataGrid row actions
 */
const DataGridDeleteAction = (props: IconButtonProps): JSX.Element => (
  <GridActionsCellItem
    // @ts-expect-error: allow "error" even though it's not in the type for color
    color="error"
    icon={<Icon width={20} icon="ic:outline-delete" />}
    label="Delete"
    {...props}
  />
);

export default DataGridDeleteAction;
